
import './App.css';
import { BrowserRouter as Router, Routes } from 'react-router-dom';
import { routesWithHeader } from './router/routeDefinitions';
import { CookieConsent } from './components/cookieConsent/cookieConsent';
import { CookieConsentProvider } from './components/cookieConsent/cookieContext';

function App() {
	return (
		<>
			<CookieConsentProvider>
				<Router>
					<Routes>
						{routesWithHeader}
					</Routes>
				</Router>
				<CookieConsent />
			</CookieConsentProvider>
		</>
	);
}

export default App;

